import React from "react";
import "./burgerMenu.css"; // sadə css faylı
import Logo from "../../../../assets/images/pro_bill_logo.svg";

const BurgerMenu = ({ isOpen, setIsOpen, setRegister }) => {
  return (
    <div className={`burger-overlay ${isOpen ? "active" : ""}`} onClick={() => setIsOpen(false)}>
      <div className={`burger-menu ${isOpen ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
        {/* TOP HEADER */}
        <div className="mobile-header">
          <a href="#" onClick={() => setIsOpen(false)}>
            <img src={Logo} alt="Probill" />
          </a>

          <div className="close-btn" onClick={() => setIsOpen(false)}>
            <span>✕</span>
          </div>
        </div>

        {/* MENU LINKS */}
        <ul className="burger-list">
          <li>
            <a href="#tutorial" onClick={() => setIsOpen(false)}>
              Probill nədir?
            </a>
          </li>
          <li>
            <a href="#customers" onClick={() => setIsOpen(false)}>
              Müştərilərimiz
            </a>
          </li>
          <li>
            <a href="#products" onClick={() => setIsOpen(false)}>
              Məhsullar
            </a>
          </li>
          <li>
            <a href="#forWho" onClick={() => setIsOpen(false)}>
              Kimlər üçündür?
            </a>
          </li>
          <li>
            <a href="#solutions" onClick={() => setIsOpen(false)}>
              Həllər
            </a>
          </li>
          <li>
            <a href="#contact" onClick={() => setIsOpen(false)}>
              Əlaqə
            </a>
          </li>
        </ul>

        {/* BOTTOM BUTTONS */}
        <div className="burger-bottom">
          <button
            className="burger-demo"
            onClick={() => {
              setRegister(true);
              setIsOpen(false);
            }}
          >
            Demo
          </button>

          <div className="burger-lang">
            <select>
              <option>AZE</option>
              <option>ENG</option>
              <option>RUS</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BurgerMenu;
